/* eslint-disable indent,react/jsx-no-literals */
import React from 'react';

const ApiDocs = () => {
    return (
        <html>
        <head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="icon" type="image/png" href="/page-data/api/images/favicon.ico" sizes="32x32" />
            <title>GraphQL API Reference</title>
            <link rel="stylesheet" href="/page-data/api/stylesheets/spectaql.min.css" />
        </head>
        <body id="spectaql">
            <div id="page" className="drawer-layout">
                <div id="sidebar">
                    <div className="sidebar-top-container">
                        <div id="logo">
                            <img src="/page-data/api/images/escapia-logo.png" title="GraphQL API Reference"/></div>
                        <button className="close-button" type="button">
                            <span aria-hidden="true">×</span>
                            <span className="sr-only">Close menu</span>
                        </button>
                    </div>
                    <nav id="nav" role="navigation">
                        <div className="nav-group">
                            <h4 className="nav-group-title">Operations</h4>
                            <ul className="nav-group-items">
                                <li>
                                    <a href="#" />
                                </li>
                                <li className="nav-group-section">
                                    <h5 className="nav-group-section-title">
                                        <a href="#group-Operations-Mutations">Mutations</a>
                                    </h5>
                                    <ul className="nav-group-section-items">
                                        <li>
                                            <a href="#mutation-reservation_CreateReservation">reservation_CreateReservation</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="nav-group">
                            <h4 className="nav-group-title">Types</h4>
                            <ul className="nav-group-items">
                                <li>
                                    <a href="#definition-BookingChannel">BookingChannel</a>
                                </li>
                                <li>
                                    <a href="#definition-Boolean">Boolean</a>
                                </li>
                                <li>
                                    <a href="#definition-CountryIsoCode">CountryIsoCode</a>
                                </li>
                                <li>
                                    <a href="#definition-Date">Date</a>
                                </li>
                                <li>
                                    <a href="#definition-DigitsOnly">DigitsOnly</a>
                                </li>
                                <li>
                                    <a href="#definition-E164">E164</a>
                                </li>
                                <li>
                                    <a href="#definition-EmailAddress">EmailAddress</a>
                                </li>
                                <li>
                                    <a href="#definition-Error">Error</a>
                                </li>
                                <li>
                                    <a href="#definition-EscapiaError">EscapiaError</a>
                                </li>
                                <li>
                                    <a href="#definition-Float">Float</a>
                                </li>
                                <li>
                                    <a href="#definition-Int">Int</a>
                                </li>
                                <li>
                                    <a href="#definition-IsoCurrencyCode">IsoCurrencyCode</a>
                                </li>
                                <li>
                                    <a href="#definition-PaymentCardType">PaymentCardType</a>
                                </li>
                                <li>
                                    <a href="#definition-PhoneType">PhoneType</a>
                                </li>
                                <li>
                                    <a href="#definition-ReservationStatus">ReservationStatus</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_AddressInput">Reservation_AddressInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_BaseRentInput">Reservation_BaseRentInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_BookingChannelCollectedDetailsInput">Reservation_BookingChannelCollectedDetailsInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_CardTokenInput">Reservation_CardTokenInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_ChannelCollectedAmountDetails">Reservation_ChannelCollectedAmountDetails</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_CreateReservationInput">Reservation_CreateReservationInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_CreateReservationPayload">Reservation_CreateReservationPayload</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_CreateReservationResponse">Reservation_CreateReservationResponse</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_FeeInput">Reservation_FeeInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_GuestCountInput">Reservation_GuestCountInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_GuestInput">Reservation_GuestInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PaymentCardInput">Reservation_PaymentCardInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PaymentInput">Reservation_PaymentInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PaymentMethodInput">Reservation_PaymentMethodInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PaymentSchedule">Reservation_PaymentSchedule</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PetInput">Reservation_PetInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PhoneInput">Reservation_PhoneInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_PriceDetailsInput">Reservation_PriceDetailsInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_StayDateRangeInput">Reservation_StayDateRangeInput</a>
                                </li>
                                <li>
                                    <a href="#definition-Reservation_TaxInput">Reservation_TaxInput</a>
                                </li>
                                <li>
                                    <a href="#definition-StateProvinceIsoCode">StateProvinceIsoCode</a>
                                </li>
                                <li>
                                    <a href="#definition-String">String</a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div id="docs">
                    <div id="mobile-navbar">
                        <button className="sidebar-open-button" type="button">
                            <span className="hamburger" />
                            <span className="sr-only">All topics</span>
                        </button>
                    </div>
                    <article id="content">
                        <h1 className="doc-heading">GraphQL API Reference</h1>
                        <h1 id="group-Operations-Mutations" className="group-heading" data-traverse-target="group-Operations-Mutations">Mutations</h1>
                        <section id="mutation-reservation_CreateReservation" className="operation operation-mutation" data-traverse-target="mutation-reservation_CreateReservation">
                            <h2 className="operation-heading "> <code>reservation_CreateReservation</code> </h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="operation-response doc-copy-section">
                                        <h5>Response</h5>
                                        <p> Returns a
                                            <a href="#definition-Reservation_CreateReservationPayload"><code>Reservation_CreateReservationPayload!</code></a>
                                        </p>
                                    </div>
                                    <div className="operation-arguments doc-copy-section">
                                        <h5>Arguments</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>input</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_CreateReservationInput"><code>Reservation_CreateReservationInput!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <h4 className="example-heading">Example</h4>
                                    <div className="example-section example-section-is-code operation-query-example">
                                        <h5>Query</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol"><span className="hljs-keyword">mutation</span> reservationCreateReservation<span className="hljs-tag">(<span className="hljs-code">$input</span>:<span className="hljs-type"> Reservation_CreateReservationInput!</span>)</span> <span className="hljs-tag">{'{'}{'\n'}{'  '}<span className="hljs-symbol">reservation_CreateReservation<span className="hljs-tag">(input: <span className="hljs-code">$input</span>)</span> <span className="hljs-tag">{'{'}{'\n'}{'    '}<span className="hljs-symbol">success</span>{'\n'}{'    '}<span className="hljs-symbol">errors <span className="hljs-tag">{'{'}{'\n'}{'      '}<span className="hljs-type">...EscapiaErrorFragment</span>{'\n'}{'    '}{'}'}</span></span>{'\n'}{'    '}<span className="hljs-symbol">payload <span className="hljs-tag">{'{'}{'\n'}{'      '}<span className="hljs-type">...Reservation_CreateReservationResponseFragment</span>{'\n'}{'    '}{'}'}</span></span>{'\n'}{'  '}{'}'}</span></span>{'\n'}{'}'}</span></span>{'\n'}</code></pre>
                                    </div>
                                    <div className="example-section example-section-is-code operation-variables-example">
                                        <h5>Variables</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span><span className="hljs-attr">"input"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_CreateReservationInput</span><span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                    <div className="example-section example-section-is-code operation-response-example">
                                        <h5>Response</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"data"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">{'{'}</span>{'\n'}{'    '}<span className="hljs-attr">"reservation_CreateReservation"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">{'{'}</span>{'\n'}{'      '}<span className="hljs-attr">"success"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">true</span></span><span className="hljs-punctuation">,</span>{'\n'}{'      '}<span className="hljs-attr">"errors"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">EscapiaError</span><span className="hljs-punctuation">]</span><span className="hljs-punctuation">,</span>{'\n'}{'      '}<span className="hljs-attr">"payload"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_CreateReservationResponse</span>{'\n'}{'    '}<span className="hljs-punctuation">{'}'}</span>{'\n'}{'  '}<span className="hljs-punctuation">{'}'}</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <h1 id="group-Types" className="group-heading" data-traverse-target="group-Types">Types</h1>
                        <section id="definition-BookingChannel" className="definition definition-scalar" data-traverse-target="definition-BookingChannel">
                            <h2 className="definition-heading">BookingChannel</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>Booking channel validator</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"AIRBNB"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Boolean" className="definition definition-scalar" data-traverse-target="definition-Boolean">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Boolean</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>The <code>Boolean</code> scalar type represents <code>true</code> or <code>false</code>.</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-literal"><span className="hljs-keyword">true</span></span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-CountryIsoCode" className="definition definition-scalar" data-traverse-target="definition-CountryIsoCode">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">CountryIsoCode</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p> A GraphQL Scalar object that validates countries for the ISO standard </p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">CountryIsoCode</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Date" className="definition definition-scalar" data-traverse-target="definition-Date">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Date</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>Date custom scalar type</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"2007-12-03"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-DigitsOnly" className="definition definition-scalar" data-traverse-target="definition-DigitsOnly">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">DigitsOnly</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p> A GraphQL Scalar type that validates only digits can be supplied </p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-number">12345</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-E164" className="definition definition-scalar" data-traverse-target="definition-E164">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">E164</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p> A GraphQL Scalar object that validates phone numbers for the international E164 standard </p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"5557896589"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-EmailAddress" className="definition definition-scalar" data-traverse-target="definition-EmailAddress">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">EmailAddress</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p> A GraphQL Scalar type that validates proper email addresses </p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"test@test.com"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Error" className="definition definition-interface" data-traverse-target="definition-Error">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Error</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties definition-fields doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Field Name</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>message</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>code</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="definition-properties definition-possible-types doc-copy-section">
                                        <h5>Possible Types</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Error Types</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <p>
                                                        <a href="#definition-EscapiaError"><code>EscapiaError</code></a>
                                                    </p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"message"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"code"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-EscapiaError" className="definition definition-object" data-traverse-target="definition-EscapiaError">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">EscapiaError</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Field Name</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>message</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>code</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>category</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>subcategory</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>marker</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>instanceId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"message"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"code"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"category"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"subcategory"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"marker"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"instanceId"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Float" className="definition definition-scalar" data-traverse-target="definition-Float">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Float</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>The <code>Float</code> scalar type represents signed double-precision fractional values as specified by
                                            <a href="https://en.wikipedia.org/wiki/IEEE_floating_point">IEEE 754</a>.</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-number">987.65</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Int" className="definition definition-scalar" data-traverse-target="definition-Int">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Int</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>The <code>Int</code> scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-number">987</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-IsoCurrencyCode" className="definition definition-scalar" data-traverse-target="definition-IsoCurrencyCode">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">IsoCurrencyCode</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>iso currency code scalar type</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"USD"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-PaymentCardType" className="definition definition-scalar" data-traverse-target="definition-PaymentCardType">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">PaymentCardType</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>payment card type scalar type</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"AMEX"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-PhoneType" className="definition definition-scalar" data-traverse-target="definition-PhoneType">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">PhoneType</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>Phone type scalar type</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"MOBILE"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-ReservationStatus" className="definition definition-enum" data-traverse-target="definition-ReservationStatus">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">ReservationStatus</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Values</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Enum Value</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <p><code>UNCONFIRMED</code></p>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p><code>CONFIRMED</code></p>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p><code>IN_PROGRESS</code></p>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p><code>COMPLETE</code></p>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p><code>CANCELED</code></p>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"UNCONFIRMED"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_AddressInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_AddressInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_AddressInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>addressLine1</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>addressLine2</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>city</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>stateProvinceIsoCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-StateProvinceIsoCode"><code>StateProvinceIsoCode</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>postcode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>countryIsoCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-CountryIsoCode"><code>CountryIsoCode</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"addressLine1"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"addressLine2"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"city"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"stateProvinceIsoCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">StateProvinceIsoCode</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"postcode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"countryIsoCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">CountryIsoCode</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_BaseRentInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_BaseRentInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_BaseRentInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>amount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>totalTax</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Override BaseRent Amount </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>taxes</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_TaxInput"><code>[Reservation_TaxInput!]</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total of taxes on baseRent should be total of taxes array </p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"amount"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987.65</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"totalTax"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987.65</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"taxes"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">Reservation_TaxInput</span><span className="hljs-punctuation">]</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_BookingChannelCollectedDetailsInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_BookingChannelCollectedDetailsInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_BookingChannelCollectedDetailsInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>grandTotalCollectedFromTraveler</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>totalTaxCollectedFromTraveler</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total amount collected from traveler </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>totalTaxRemittedByChannel</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total tax amount collected from traveler </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>travelerServiceFee</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total tax amount remitted by channel </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>commissionsAndDeductionsFromPM</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Amount of service fee traveler charged </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>grandTotalPaidToPM</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total Amount of any commissions deducted from PM </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>totalTaxToBeRemittedByPM</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total Amount PM will receive for reservation </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isPmMerchantOfRecord</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total tax amount PM needs to remit </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isCommissionPreDeducted</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>channelCollectedAmountDetails</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_ChannelCollectedAmountDetails"><code>[Reservation_ChannelCollectedAmountDetails!]</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"grandTotalCollectedFromTraveler"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"totalTaxCollectedFromTraveler"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"totalTaxRemittedByChannel"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"travelerServiceFee"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"commissionsAndDeductionsFromPM"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"grandTotalPaidToPM"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987.65</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"totalTaxToBeRemittedByPM"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"isPmMerchantOfRecord"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">false</span></span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"isCommissionPreDeducted"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">false</span></span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"channelCollectedAmountDetails"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span>{'\n'}{'    '}<span className="hljs-string">Reservation_ChannelCollectedAmountDetails</span>{'\n'}{'  '}<span className="hljs-punctuation">]</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_CardTokenInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_CardTokenInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_CardTokenInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>tokenId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>maskedCardNumber</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"tokenId"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"maskedCardNumber"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_ChannelCollectedAmountDetails" className="definition definition-input-object" data-traverse-target="definition-Reservation_ChannelCollectedAmountDetails">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_ChannelCollectedAmountDetails</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>amount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>name</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> An Amount </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>description</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> A name for the collected info </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isRemittedByChannel</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> A description for the collected info </p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"amount"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"name"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"description"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"isRemittedByChannel"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">true</span></span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_CreateReservationInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_CreateReservationInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_CreateReservationInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>externalTransactionIdentifier</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>bookingChannelCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-BookingChannel"><code>BookingChannel</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>propertyManagerId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>unitId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>stayDate</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_StayDateRangeInput"><code>Reservation_StayDateRangeInput!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>guestCount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_GuestCountInput"><code>Reservation_GuestCountInput!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>guests</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_GuestInput"><code>[Reservation_GuestInput!]!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>comment</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>payment</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PaymentInput"><code>Reservation_PaymentInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>petCount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PetInput"><code>Reservation_PetInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>priceDetails</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PriceDetailsInput"><code>Reservation_PriceDetailsInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"externalTransactionIdentifier"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"bookingChannelCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"AIRBNB"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"propertyManagerId"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"unitId"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"stayDate"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_StayDateRangeInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"guestCount"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_GuestCountInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"guests"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">Reservation_GuestInput</span><span className="hljs-punctuation">]</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"comment"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"payment"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PaymentInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"petCount"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PetInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"priceDetails"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PriceDetailsInput</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_CreateReservationPayload" className="definition definition-object" data-traverse-target="definition-Reservation_CreateReservationPayload">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_CreateReservationPayload</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Field Name</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>success</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>errors</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-EscapiaError"><code>[EscapiaError!]!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>payload</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_CreateReservationResponse"><code>Reservation_CreateReservationResponse</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"success"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">false</span></span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"errors"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">EscapiaError</span><span className="hljs-punctuation">]</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"payload"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_CreateReservationResponse</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_CreateReservationResponse" className="definition definition-object" data-traverse-target="definition-Reservation_CreateReservationResponse">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_CreateReservationResponse</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Field Name</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>reservationNumber</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>reservationId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td data-property-name>
                                                    <span className="property-name"><code>reservationStatus</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-ReservationStatus"><code>ReservationStatus</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"reservationNumber"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"reservationId"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"reservationStatus"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"UNCONFIRMED"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_FeeInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_FeeInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_FeeInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>classicId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>name</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Id of fee retrieved from LOS API </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>productCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Name of fee retrieved from LOS API </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>amount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> ProductCode of Fee retrieved from LOS API </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>totalTax</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Override Fee Amount </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>taxes</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_TaxInput"><code>[Reservation_TaxInput!]</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p> Total of taxes on Fee should be total of taxes array </p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"classicId"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"name"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"productCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"amount"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987.65</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"totalTax"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"taxes"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">Reservation_TaxInput</span><span className="hljs-punctuation">]</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_GuestCountInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_GuestCountInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_GuestCountInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>adults</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>children</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span><span className="hljs-attr">"adults"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span> <span className="hljs-attr">"children"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_GuestInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_GuestInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_GuestInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isPrimary</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>namePrefix</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>firstName</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>middleName</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>lastName</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>nameSuffix</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>email</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-EmailAddress"><code>EmailAddress</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>phone</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PhoneInput"><code>Reservation_PhoneInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>address</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_AddressInput"><code>Reservation_AddressInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"isPrimary"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">false</span></span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"namePrefix"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"firstName"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"middleName"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"lastName"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"nameSuffix"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"abc123"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"email"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"test@test.com"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"phone"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PhoneInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"address"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_AddressInput</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PaymentCardInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PaymentCardInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PaymentCardInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>cardToken</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_CardTokenInput"><code>Reservation_CardTokenInput!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>expirationMonth</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>expirationYear</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>cardHolderName</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>cardType</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-PaymentCardType"><code>PaymentCardType</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>billingAddress</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_AddressInput"><code>Reservation_AddressInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isVirtualCard</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td>
                                                    <p>The functionality for isVirtualCard field is not implemented yet.</p>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"cardToken"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_CardTokenInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"expirationMonth"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"expirationYear"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"cardHolderName"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"cardType"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"AMEX"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"billingAddress"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_AddressInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"isVirtualCard"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">true</span></span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PaymentInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PaymentInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PaymentInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>currencyCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-IsoCurrencyCode"><code>IsoCurrencyCode!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>paymentSchedule</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PaymentSchedule"><code>[Reservation_PaymentSchedule!]</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>paymentMethod</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PaymentMethodInput"><code>Reservation_PaymentMethodInput!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"currencyCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"USD"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"paymentSchedule"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">Reservation_PaymentSchedule</span><span className="hljs-punctuation">]</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"paymentMethod"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PaymentMethodInput</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PaymentMethodInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PaymentMethodInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PaymentMethodInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>paymentCard</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_PaymentCardInput"><code>Reservation_PaymentCardInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span><span className="hljs-attr">"paymentCard"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_PaymentCardInput</span><span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PaymentSchedule" className="definition definition-input-object" data-traverse-target="definition-Reservation_PaymentSchedule">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PaymentSchedule</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>amount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>paymentProcessingDate</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Date"><code>Date</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"amount"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987.65</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"paymentProcessingDate"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"2007-12-03"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PetInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PetInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PetInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>numberOfDogs</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>numberOfCats</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span><span className="hljs-attr">"numberOfDogs"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987</span><span className="hljs-punctuation">,</span> <span className="hljs-attr">"numberOfCats"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">987</span><span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PhoneInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PhoneInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PhoneInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>e164</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-E164"><code>E164!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>extension</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-DigitsOnly"><code>DigitsOnly</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>type</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-PhoneType"><code>PhoneType!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"e164"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"5557896589"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"extension"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">12345</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"type"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"MOBILE"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_PriceDetailsInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_PriceDetailsInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_PriceDetailsInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>currencyCode</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-IsoCurrencyCode"><code>IsoCurrencyCode</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>baseRent</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_BaseRentInput"><code>Reservation_BaseRentInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>fees</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_FeeInput"><code>[Reservation_FeeInput!]</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>bookingChannelCollectedDetails</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Reservation_BookingChannelCollectedDetailsInput"><code>Reservation_BookingChannelCollectedDetailsInput</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"currencyCode"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"USD"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"baseRent"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_BaseRentInput</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"fees"</span><span className="hljs-punctuation">:</span> <span className="hljs-punctuation">[</span><span className="hljs-string">Reservation_FeeInput</span><span className="hljs-punctuation">]</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"bookingChannelCollectedDetails"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">Reservation_BookingChannelCollectedDetailsInput</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_StayDateRangeInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_StayDateRangeInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_StayDateRangeInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>arrival</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Date"><code>Date!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>departure</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Date"><code>Date!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"arrival"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"2007-12-03"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"departure"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"2007-12-03"</span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-Reservation_TaxInput" className="definition definition-input-object" data-traverse-target="definition-Reservation_TaxInput">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">Reservation_TaxInput</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-properties doc-copy-section">
                                        <h5>Fields</h5>
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Input Field</th>
                                                <th>Description</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>classicId</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Int"><code>Int</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>amount</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Float"><code>Float!</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>name</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>description</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-String"><code>String</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span className="property-name"><code>isRemittedByChannel</code></span> -
                                                    <span className="property-type">
                                <a href="#definition-Boolean"><code>Boolean</code></a>
                              </span>
                                                </td>
                                                <td> </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-json"><span className="hljs-punctuation">{'{'}</span>{'\n'}{'  '}<span className="hljs-attr">"classicId"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"amount"</span><span className="hljs-punctuation">:</span> <span className="hljs-number">123.45</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"name"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"description"</span><span className="hljs-punctuation">:</span> <span className="hljs-string">"xyz789"</span><span className="hljs-punctuation">,</span>{'\n'}{'  '}<span className="hljs-attr">"isRemittedByChannel"</span><span className="hljs-punctuation">:</span> <span className="hljs-literal"><span className="hljs-keyword">false</span></span>{'\n'}<span className="hljs-punctuation">{'}'}</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-StateProvinceIsoCode" className="definition definition-scalar" data-traverse-target="definition-StateProvinceIsoCode">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">StateProvinceIsoCode</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p> A GraphQL Scalar object that validates states/provinces for the ISO standard </p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">StateProvinceIsoCode</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="definition-String" className="definition definition-scalar" data-traverse-target="definition-String">
                            <div className="definition-group-name">
                                <a href="#group-Types">Types</a>
                            </div>
                            <h2 className="definition-heading">String</h2>
                            <div className="doc-row">
                                <div className="doc-copy">
                                    <div className="definition-description doc-copy-section">
                                        <h5>Description</h5>
                                        <p>The <code>String</code> scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.</p>
                                    </div>
                                </div>
                                <div className="doc-examples">
                                    <div className="example-section example-section-is-code">
                                        <h5>Example</h5>
                                        <pre><code className="hljs language-gql"><span className="hljs-symbol">"xyz789"</span>{'\n'}</code></pre>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </article>
                    <div className="drawer-overlay" />
                </div>
            </div>
        </body>
        </html>
    );
};

export default ApiDocs;

